/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MerchantMerchantCategory } from './merchantMerchantCategory';
import { MerchantMerchantSubCategory } from './merchantMerchantSubCategory';


export interface Merchant { 
    archived?: boolean;
    chowNowLink?: string;
    createdAt?: string;
    description?: string;
    doordashLink?: string;
    email?: string;
    facebookLink?: string;
    featuredOnHomePage?: boolean;
    featuredOnHomePageLink?: string;
    grubhubLink?: string;
    grubhubWorkLink?: string;
    id?: string;
    imageFive?: string;
    imageFour?: string;
    imageOne?: string;
    imageThree?: string;
    imageTwo?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    instagramLink?: string;
    locked?: boolean;
    mercatoLink?: string;
    merchantCategory?: MerchantMerchantCategory;
    merchantSubCategory?: MerchantMerchantSubCategory;
    path?: string;
    phone?: string;
    postmatesLink?: string;
    published?: boolean;
    readOnly?: boolean;
    seamlessLink?: string;
    stall?: string;
    theOfficeExpressLink?: string;
    title?: string;
    twitterLink?: string;
    uberEatsLink?: string;
    updatedAt?: string;
    version?: number;
    website?: string;
    youtubeEmbedLink?: string;
}
